/**
 * @param {Object} user
 *
 * @return {String}
 */
function getDisplayName (user) {
  if (user.username) {
    return user.username
  }

  return user.email
}

/**
 * @param {Object} user
 *
 * @return {Object}
 */
export default function formatUser (user) {
  return {
    email: user.email,
    displayName: getDisplayName(user),
    id: user.id,
    nom: user.nom,
    prenom: user.prenom,
    depotVente: {
      id: user.depotVente.id,
      raisonSociale: user.depotVente.raisonSociale,
      codePostal: user.depotVente.codePostal,
      ville: user.depotVente.ville
    },
    token: user.token
  }
}
